import { createFileRoute, redirect } from '@tanstack/react-router';

// The legacy /admin/settings page only duplicated the personal profile,
// calendar connections, cross-campaign visibility, and Change Password cards
// that already live on the canonical /app/settings. The route is retained as a
// redirect stub (no component) so existing bookmarks and login-redirect
// deep-links resolve to /app/settings instead of 404ing.
export const Route = createFileRoute('/admin/settings')({
  beforeLoad: () => {
    throw redirect({ to: '/app/settings' });
  },
});
